export NotFound from './NotFound/NotFound';
export TakePasswordOne from './TakePassword/TakePasswordOne';
export TakePasswordTwo from './TakePassword/TakePasswordTwo';
export TakePasswordThree from './TakePassword/TakePasswordThree';